module.exports = __webpack_public_path__ + "static/media/48-kitchen.ce6d16ea.jpg";